<template>
  <div style="max-height: 100%; height: 100%">
    <user-joinin-drop v-if="waitingParticipants.length" />

    <div style="width: 100%; height: 100%; display: flex">
      <div style="flex: 2; width: 100%; height: 100%" v-if="screenShare">
        <VideoTrack :rotate="false" :track="screenShare.screenVideoTrack" />
      </div>
      <div style="flex: 1; width: 100%; height: 100%">
        <div v-if="participants.length > 1">
          <participant-tile
            :participant="participant"
            :participantsNumber="participants.length"
          />
          <div>
            {{ $store.state.meeting.transcript[participant.user_id] }}
          </div>
        </div>

        <div v-else class="participant-container">
          <participant-tile
            :participant="localParticipant"
            :participantsNumber="1"
          />
          <waiting-for-others />
        </div>
      </div>
    </div>
    <!--    <div
          :class="participants.length > 2 && participants.length < 5 ? 'p-184' : ''"
        >
          <div
            v-for="(participant, index) in participants"
            :key="participant.user_id"
            :class="
              participants.length > 0 && participants.length < 3
                ? `w-50 participants-2-height ${
                    index % 2 == 0 ? 'no-padding-left' : 'no-padding-right'
                  }`
                : participants.length > 2 && participants.length < 5
                ? `w-50 participants-4-height ${
                    index % 2 == 0 ? 'no-padding-left' : 'no-padding-right'
                  }`
                : `w-25 participants-8-height ${
                    index == 0 || index % 4 == 0
                      ? 'no-padding-left'
                      : index % 3 == 0
                      ? 'no-padding-right'
                      : ''
                  }`
            "
          >
            <participant-screen-share
              :participant="participant"
              v-if="participant.screen"
            />
            <participant-tile
              :participant="participant"
              :participantsNumber="participants.length"
            />
          </div>
          <div
            :class="
              participants.length > 0 && participants.length < 3
                ? `w-50 participants-2-height ${
                    index % 2 == 0 ? 'no-padding-left' : 'no-padding-right'
                  }`
                : participants.length > 2 && participants.length < 5
                ? `w-50 participants-4-height ${
                    index % 2 == 0 ? 'no-padding-left' : 'no-padding-right'
                  }`
                : 'w-25 participants-8-height'
            "
            v-if="participants.length < 2"
          >
            <waiting-for-others />
          </div>
        </div>
        &lt;!&ndash; <div style="background: chartreuse">
          <h3>Reactions (check console for events coming through)</h3>
          <button style="margin-right: 8px; background: brown; color: white" @click="$store.dispatch('sendReaction', 'Reaction1')">Send Reaction 1</button>
          <button style="margin-right: 8px; background: brown; color: white" @click="$store.dispatch('sendReaction', 'Reaction2')">Send Reaction 2</button>
          <button style="margin-right: 8px; background: brown; color: white" @click="$store.dispatch('sendReaction', 'Reaction3')">Send Reaction 3</button>
        </div> &ndash;&gt;
        &lt;!&ndash; <participant-list /> &ndash;&gt;
        &lt;!&ndash; <participants /> &ndash;&gt;
        <actions style="padding-top: 159px" />
        &lt;!&ndash; <controls /> &ndash;&gt;
        &lt;!&ndash; <select-devices /> &ndash;&gt;
        &lt;!&ndash; <update-room-theme v-if="localParticipant.owner" /> &ndash;&gt;;-->
    <!-- <message-list :messages="messages" />
    <MessageInput v-bind:roomId="roomId" v-bind:meetingId="meetingId" /> -->
  </div>
</template>

<script>
import RoomInfoScreen from "../roomInfoScreen";
import MeettingLockUnlock from "../meettingLockUnlock";
import UserJoininDrop from "../userJoininDrop";
import TileGrid from "../TileGrid";
import Controls from "../Controls";
import VideoTrack from "../VideoTrack";
import ParticipantList from "./ParticipantList";
import MessageList from "./MessageList";
import MessageInput from "../chat/MessageInput";
import ParticipantTile from "./ParticipantTile";
import waitingForOthers from "../waitingForOthers";
import Participants from "../Participants";
import ParticipantScreenShare from "./ParticipantScreenShare";
import SelectDevices from "./SelectDevices";
import UpdateRoomTheme from "./UpdateRoomTheme";
import ChatInput from "./ChatInput";
import Chat from "../chat/Chat";
import Actions from "./Actions";
import ResponsiveGrid from "../ResponsiveGrid";

export default {
  name: "JoinedMeeting",
  components: {
    ResponsiveGrid,
    ChatInput,
    UpdateRoomTheme,
    SelectDevices,
    ParticipantScreenShare,
    ParticipantTile,
    MessageInput,
    MessageList,
    ParticipantList,
    VideoTrack,
    Controls,
    TileGrid,
    UserJoininDrop,
    MeettingLockUnlock,
    RoomInfoScreen,
    waitingForOthers,
    Participants,
    Actions,
  },
  computed: {
    screenShare() {
      return this.participants.find((it) => it.screen);
    },
    waitingParticipants() {
      return this.$store.state.meeting.waitingParticipants;
    },
    localParticipant() {
      return this.$store.getters.localParticipant;
    },
    participants() {
      return this.$store.state.meeting.participants;
    },
    messages() {
      return this.$store.state.meeting.messages;
    },
    roomId() {
      return this.$store.state.meeting.roomId;
    },
    meetingId() {
      return this.$store.state.meeting.id;
    },
  },
  methods: {
    async sendMessage(message) {
      console.log(message);
      await this.$store.dispatch("sendMessage", message);
    },
  },
  mounted() {
    console.log(this.$store.state.meeting);
  },
  beforeUnmount() {
    this.$store.dispatch("leaveMeeting");
  },
  // mounted() {
  //   var el = document.getElementsByClassName("modal_overlay")[0];
  //   el.classList.remove("active");
  //   document
  //     .getElementsByClassName("no_scroll")[0]
  //     .classList.remove("no_scroll");
  // },
};
</script>

<style scoped lang="scss">
.participant-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  height: 100%;


  margin-left: auto;
  margin-right: auto;
}
</style>
